import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Triggercard from "./Triggercard";
import Actioncard from "./Actioncard";
import { getToken } from "../../Utils/Common";
const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

const Accordiontab = (props) => {
  const classes = useStyles();

  const [expanded, setExpanded] = useState(false);

  const [metadata, setMetadata] = useState([]);

  const [trigger_node, setTriggernode] = useState([]);

  const [workflow_node, setWorkflownode] = useState([]);

  const [deliverychannel_node, setDeliverychannelnode] = useState([]);

  const [accountaction_node, setAccountaction] = useState([]);

  const [crm_node, setCrmnode] = useState([]);

  const [apps_node, setAppsnodes] = useState([]);

  const [sales_node, setSalesnode] = useState([]);

  useEffect(() => {
    const token = "Bearer " + getToken();
    // Action Api call
    axios
      .get(process.env.REACT_APP_API_BASE_URL + "workflows/metadata", {
        headers: {
          Authorization: token,
        },
      })
      .then((response) => {

        setCrmnode(response.data.Action["CRM"]);

        setWorkflownode(response.data.Action["Workflow Node"]);

        setDeliverychannelnode(response.data.Action["Delivery Channels"]);

        setAccountaction(response.data.Action["Account Action"]);

        setSalesnode(response.data.Action["Sales Action"]);

        setTriggernode(Object.keys(response.data.StartEvent));

        let apps = [];
        Object.keys(response.data.Action.App).map((key) => {
          var app_data = {
            name: key,
            isInstalled: false,
          };

          response.data.Action.App[key].some((app) => {
            if (app.isInstalled) {
              app_data.isInstalled = true;
              app_data.name = key;
            }
          });
          apps.push(app_data);
        });
        setAppsnodes(apps);

        //Array of App
        // response.data.Action.App
      })
      .catch((e) => {

      });
  }, []);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div style={{ width: 300, padding: "15px" }}>
      {/* <button
        onClick={props.urlToAllWorkflows}
        className="sm_btn primary kw_wf_button"
        style={{ width: "100%", backgroundColor: "#2C40CE" }}
      >
        Exit
      </button> */}
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
        className={classes.accordion_style}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography className={classes.heading}>Trigger</Typography>
        </AccordionSummary>
        <div className="trigger_accordion">
          {trigger_node.map((node) => {

            return (
              <AccordionDetails>
                <Triggercard node_data={node} type="default"></Triggercard>
              </AccordionDetails>
            );
          })}
        </div>
      </Accordion>
      {/* Delivery Channels */}
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
        className={classes.accordion_style}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography className={classes.heading}>Delivery Channels</Typography>
        </AccordionSummary>
        <div className="delivery_accordion">
          {deliverychannel_node.map((node) => {
            return (
              <AccordionDetails>
                <Actioncard
                  node_data={node}
                  type="default"
                  category="Action"
                ></Actioncard>
              </AccordionDetails>
            );
          })}
        </div>
      </Accordion>
      {/* Workflow Node */}
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
        className={classes.accordion_style}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography className={classes.heading}>Workflow Node</Typography>
        </AccordionSummary>
        <div className="worklflow_accordion">
          {workflow_node.map((node) => {
            return (
              <AccordionDetails>
                <Actioncard
                  node_data={node}
                  type="default"
                  category="Action"
                ></Actioncard>
              </AccordionDetails>
            );
          })}
        </div>
      </Accordion>
      {/* Account Action */}
      <Accordion
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
        className={classes.accordion_style}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography className={classes.heading}>Contact Action</Typography>
        </AccordionSummary>
        <div className="account_accordion">
          {accountaction_node &&
            accountaction_node.map((node) => {
              return (
                <AccordionDetails>
                  <Actioncard
                    node_data={node}
                    type="default"
                    category="Action"
                  ></Actioncard>
                </AccordionDetails>
              );
            })}
        </div>
      </Accordion>
      {/* Apps */}
      <Accordion
        expanded={expanded === "panel6"}
        onChange={handleChange("panel6")}
        className={classes.accordion_style}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography className={classes.heading}>Apps</Typography>
        </AccordionSummary>
        <div className="apps_accordion">
          {apps_node.map((node) => {

            return (
              <AccordionDetails>
                <Actioncard
                  node_data={node}
                  type="default"
                  category="App"
                ></Actioncard>
              </AccordionDetails>
            );
          })}
        </div>
      </Accordion>
      {/* Sales Action */}
      <Accordion
        expanded={expanded === "panel7"}
        onChange={handleChange("panel7")}
        className={classes.accordion_style}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography className={classes.heading}>Sales</Typography>
        </AccordionSummary>
        <div className="apps_accordion">
          {sales_node?.map((node) => {
            return (
              <AccordionDetails>
                <Actioncard
                  node_data={node}
                  type="default"
                  category="Action"
                ></Actioncard>
              </AccordionDetails>
            );
          })}
        </div>
      </Accordion>
    </div>
  );
};

export default Accordiontab;
